import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'

import FilterPagination from 'pages/parts/FilterPagination'
import { httpOk, GET, DELETE } from 'helpers/api'
import { formatMoney, returnSign, formatDate, getCurrentChequeDate, chequeDates } from 'helpers/helpers'

function Rasxodlar() {
	const { t } = useTranslation()
	const date = new Date()

	const transactionTypes = [
		{ id: 'plus', name: t('income') },
		{ id: 'minus', name: t('expense') },
	]

	const [data, setData] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [paymentPurposeTypes, setPaymentPurposeTypes] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [totalAmount, setTotalAmount] = useState(0)
	const [pagination, setPagination] = useState({ url: '/expenses', response: null })
	const [deleteModal, setDeleteModal] = useState({ show: false, item: null, note: '' })

	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		created_by: null,
		payment_purpose_id: null,
		payment_type_id: null,
		transaction_type: null,
		dateType: null,
		page: 0,
		size: 20,
	})

	async function searchWithFilter() {
		var urlParams = ""

		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date
		if (filterData.created_by)
			urlParams += returnSign(urlParams) + 'created_by=' + filterData.created_by
		if (filterData.payment_purpose_id)
			urlParams += returnSign(urlParams) + 'payment_purpose_id=' + filterData.payment_purpose_id
		if (filterData.payment_type_id)
			urlParams += returnSign(urlParams) + 'payment_type_id=' + filterData.payment_type_id
		if (filterData.transaction_type)
			urlParams += returnSign(urlParams) + 'transaction_type=' + filterData.transaction_type
		urlParams += returnSign(urlParams) + 'page=' + (filterData.page ?? 0)
		urlParams += returnSign(urlParams) + 'size=' + (filterData.size ?? 20)

		const hasFilter = filterData.created_by || filterData.payment_purpose_id ||
			filterData.payment_type_id || filterData.transaction_type
		setFilterDataExist(!!hasFilter)

		const filterUrl = '/expenses' + urlParams
		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data ?? [])
			setTotalAmount(response.data.total_amount ?? 0)
			setPagination({ url: filterUrl, response: response.data })
		}

		setDropdownIsOpen(false)
	}

	function resetFilter() {
		setFilterData({
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			created_by: null,
			payment_purpose_id: null,
			payment_type_id: null,
			transaction_type: null,
			dateType: null,
			page: 0,
			size: 20,
		})
		setFilterDataExist(false)
	}

	function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, dateType: option.id })
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, page: page - 1, size })
	}

	function deleteExpense(item) {
		setDeleteModal({ show: true, item, note: '' })
	}

	async function confirmDeleteExpense() {
		const { item, note } = deleteModal
		const response = await DELETE(`/expense/${item.id}`, { deleted_note: note }, { loader: true })
		if (httpOk(response)) {
			setDeleteModal({ show: false, item: null, note: '' })
			searchWithFilter()
		}
	}

	async function getPaymentPurposeTypes() {
		const response = await GET('/helper/ppt-expense')
		if (httpOk(response)) setPaymentPurposeTypes(response.data)
	}

	async function getCashiers() {
		const response = await GET('/helper/cashiers')
		if (httpOk(response)) setCashiers(response.data)
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	useEffect(() => {
		getCashiers()
		getPaymentPurposeTypes()
		getPaymentTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.page, filterData.size, filterData.start_date, filterData.end_date,
		filterData.created_by, filterData.payment_purpose_id,
		filterData.payment_type_id, filterData.transaction_type]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center h-100">
					{t('expenses_by_worker')} [{pagination?.response?.total ?? 0}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>

							<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
								{t('filter')}
							</Dropdown.Toggle>

							<Dropdown.Menu className="dropdown-filter">
								<div className="row">
									<div className="form-group col-md-6">
										<label>{t('cashier')}</label>
										<Select
											isClearable
											options={cashiers}
											value={cashiers.find(o => o.login === filterData.created_by) || null}
											onChange={(option) => setFilterData({ ...filterData, created_by: option ? option.login : null, page: 0 })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.login}
										/>
									</div>
									<div className="form-group col-md-6">
										<label>{t('type')}</label>
										<Select
											isClearable
											options={paymentPurposeTypes}
											value={paymentPurposeTypes.find(o => o.id === filterData.payment_purpose_id) || null}
											onChange={(option) => setFilterData({ ...filterData, payment_purpose_id: option ? option.id : null, page: 0 })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.id}
										/>
									</div>
									<div className="form-group col-md-6">
										<label>{t('payment_type')}</label>
										<Select
											isClearable
											options={paymentTypes}
											value={paymentTypes.find(o => o.id === filterData.payment_type_id) || null}
											onChange={(option) => setFilterData({ ...filterData, payment_type_id: option ? option.id : null, page: 0 })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.id}
										/>
									</div>
									<div className="form-group col-md-6">
										<label>{t('transaction_type')}</label>
										<Select
											isClearable
											options={transactionTypes}
											value={transactionTypes.find(o => o.id === filterData.transaction_type) || null}
											onChange={(option) => setFilterData({ ...filterData, transaction_type: option ? option.id : null, page: 0 })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.id}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-group col-md-4">
										<label>{t('period')}</label>
										<Select
											options={chequeDates}
											value={chequeDates.find(o => o.id === filterData.dateType) || null}
											onChange={(option) => selectChequeDates(option)}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.id}
										/>
									</div>
									<div className="form-group col-md-4">
										<label className="invisible">{t('period')}</label>
										<div className="calendar-input">
											<DatePicker
												className="form-control"
												dateFormat="dd.MM.yyyy"
												selected={filterData.start_date ? new Date(filterData.start_date) : ''}
												onChange={(d) => setFilterData({ ...filterData, start_date: formatDate(d, 'yyyy-MM-dd'), page: 0 })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
									<div className="form-group col-md-4">
										<label className="invisible">.</label>
										<div className="calendar-input">
											<DatePicker
												className="form-control"
												dateFormat="dd.MM.yyyy"
												selected={filterData.end_date ? new Date(filterData.end_date) : ''}
												onChange={(d) => setFilterData({ ...filterData, end_date: formatDate(d, 'yyyy-MM-dd'), page: 0 })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-md-12 d-flex justify-content-end gap-2">
										<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>
											{t('cancel')}
										</button>
										<button className="btn btn-primary" onClick={() => searchWithFilter()}>
											{t('apply')}
										</button>
									</div>
								</div>
							</Dropdown.Menu>
						</Dropdown>

						<div className="vertical-center">
							<h5 className="mb-0">
								{t('total')}: <span className="text-danger fw-bold">{formatMoney(totalAmount)}</span>
							</h5>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.created_by &&
									<span className="me-2">
										<b>{t('cashier')}: </b>
										{cashiers.find(o => o.login === filterData.created_by)?.name}
									</span>
								}
								{filterData.payment_purpose_id &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{paymentPurposeTypes.find(o => o.id === filterData.payment_purpose_id)?.name}
									</span>
								}
								{filterData.payment_type_id &&
									<span className="me-2">
										<b>{t('payment_type')}: </b>
										{paymentTypes.find(o => o.id === filterData.payment_type_id)?.name}
									</span>
								}
								{filterData.transaction_type &&
									<span className="me-2">
										<b>{t('transaction_type')}: </b>
										{transactionTypes.find(o => o.id === filterData.transaction_type)?.name}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th style={{ width: '10%' }}>{t('cashier')}</th>
									<th style={{ width: '13%' }}>{t('type')}</th>
									<th style={{ width: '10%' }}>{t('payment_type')}</th>
									<th style={{ width: '10%' }}>{t('account')}</th>
									<th style={{ width: '10%' }}>{t('counterparty')}</th>
									<th style={{ width: '17%' }}>{t('note')}</th>
									<th style={{ width: '12%' }} className="text-center">{t('date')}</th>
									<th style={{ width: '10%' }} className="text-end">{t('amount')}</th>
									<th style={{ minWidth: '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.length === 0 ? (
									<tr>
										<td colSpan="10" className="text-center text-muted py-4">{t('list_empty')}</td>
									</tr>
								) : (
									data.map((item, index) => (
										<tr key={index}>
											<td className="text-center">{(filterData.page * filterData.size) + index + 1}</td>
											<td className="td-ellipsis">{item.created_by}</td>
											<td className="td-ellipsis">{item.name}</td>
											<td className="td-ellipsis">{item.payment_name}</td>
											<td className="td-ellipsis">{item.account_name ?? '—'}</td>
											<td className="td-ellipsis">{item.client_name}</td>
											<td className="td-ellipsis" title={item.note}>{item.note}</td>
											<td className="text-center text-nowrap">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
											<td className={`text-end ${item.transaction_type === 'plus' ? 'text-success' : 'text-danger'}`}>
												{formatMoney(item.amount)}
											</td>
											<td className="text-center">
												<i className="uil-trash text-danger cursor" style={{ fontSize: '16px' }}
													onClick={() => deleteExpense(item)} />
											</td>
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination pagination={pagination} paginate={paginate} />
					}
				</div>
			</div>

			<Modal show={deleteModal.show} onHide={() => setDeleteModal({ show: false, item: null, note: '' })} centered>
				<Modal.Header closeButton>
					<Modal.Title>{t('delete')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">
						<b>{deleteModal.item?.name}</b> — {formatMoney(deleteModal.item?.amount)} so'm
					</div>
					<label className="form-label">{t('delete_note')} <span className="text-danger">*</span></label>
					<textarea
						className="form-control"
						rows={3}
						value={deleteModal.note}
						onChange={e => setDeleteModal(prev => ({ ...prev, note: e.target.value }))}
						placeholder={t('delete_note')}
					/>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-secondary" onClick={() => setDeleteModal({ show: false, item: null, note: '' })}>
						{t('cancel')}
					</button>
					<button
						className="btn btn-danger"
						disabled={!deleteModal.note?.trim()}
						onClick={confirmDeleteExpense}
					>
						{t('delete')}
					</button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default Rasxodlar
